/* eslint-disable react/jsx-pascal-case */
import FA from 'admin/components/atoms/FontAwesome';
import React, { useState } from 'react';
import styled from 'styled-components';

type Props = {
  isEditable?: boolean;
  onToggle?: (editableState: boolean) => void;
  onUpdate: () => void;
  onCancel: () => void;
  renderInput: () => void;
  renderValue: () => void;
};

const isUncontrolled = <T,>(state: T | undefined | null) => state === undefined || state === null;

const Icon = styled(FA)`
  cursor: pointer;
  font-size: 12px;
`;

const IconWrapper = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

const EditableTableCell = ({
  isEditable,
  onToggle,
  onUpdate,
  onCancel,
  renderInput,
  renderValue,
}: Props) => {
  const [uncontrolledIsEditable, setUncontrolledIsEditable] = useState(false);

  const setEditable = (state: boolean) => {
    if (isUncontrolled(isEditable)) {
      setUncontrolledIsEditable(state);
    } else {
      onToggle?.(state);
    }
  };

  const handleUpdate = () => {
    onUpdate();
    setEditable(false);
  };

  const handleCancel = () => {
    onCancel();
    setEditable(false);
  };

  return (
    <Wrapper>
      {isEditable ?? uncontrolledIsEditable ? (
        <>
          {renderInput()}
          <IconWrapper>
            <Icon icon="check" onClick={handleUpdate} />
            <Icon icon="times" onClick={handleCancel} />
          </IconWrapper>
        </>
      ) : (
        <>
          {renderValue()}
          <IconWrapper>
            <Icon icon="pen" onClick={() => setEditable(true)} />
          </IconWrapper>
        </>
      )}
    </Wrapper>
  );
};

export default styled(EditableTableCell)``;
